import { useWorkspace } from '@/features/workspaces/hooks';

/**
 * Gates the WhatsApp inbox behind `workspace.features.whatsappInbox.active`. Turned on DB-side,
 * merging into the existing document like the municipalities flag (see useComuniFlag):
 *   UPDATE cdp_workspace
 *   SET features = (features::jsonb || '{"whatsappInbox":{"active":true}}'::jsonb)::json
 *   WHERE external_id = 'w-...';
 */
export const useWhatsappInboxEnabled = (): boolean => !!useWorkspace().features?.whatsappInbox?.active;
